import {
  Box,
  Table as MuiTable,
  TableRow as MuiTableRow,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import React from 'react'

import MobileTableRow from './components/MobileTableRow'
import TableRow, { TableRowInformation } from './components/TableRow'

type TableProps = {
  tableHead: string[]
  tableRows: undefined | TableRowInformation[]
  title?: string
  noRowsMessage?: string
  noShadow?: boolean
  dense?: boolean
  lastCellRight?: boolean
  action?: React.ReactNode
  noDataMessage?: React.ReactNode
  shadedData?: boolean
}

export const Table = (props: TableProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <TableContainer component={Paper} sx={!props.noShadow ? {} : { boxShadow: 'none' }}>
      {props.title && (
        <Box
          sx={{
            bgcolor: 'primary.main',
            padding: 2,
          }}
        >
          <Typography component="h3" sx={{ color: 'white' }} variant="h6">
            {props.title}
          </Typography>
        </Box>
      )}
      <MuiTable
        aria-label="simple table"
        size={props.dense ? 'small' : 'medium'}
        sx={props.shadedData ? { backgroundColor: 'rgba(0,0,0,0.02) !important' } : {}}
      >
        {!isMobile && (
          <TableHead>
            <MuiTableRow>
              {props.tableHead.map((cell, cellIndex) => (
                <TableCell
                  align={props.tableHead.length === cellIndex + 1 && props.lastCellRight ? 'right' : 'inherit'}
                  key={cellIndex}
                >
                  {cell}
                </TableCell>
              ))}
            </MuiTableRow>
          </TableHead>
        )}
        <TableBody>
          {props.tableRows?.map((row, rowIndex) =>
            isMobile ? (
              <MobileTableRow key={rowIndex} row={row} rowIndex={rowIndex} tableHead={props.tableHead} />
            ) : (
              <TableRow
                key={rowIndex}
                row={row}
                rowIndex={rowIndex}
                lastCellRight={props.lastCellRight === undefined ? true : props.lastCellRight}
                tableHead={props.tableHead}
              />
            ),
          )}
          {props.tableRows?.length === 0 && (
            <MuiTableRow>
              <TableCell colSpan={props.tableHead.length}>
                {props.noRowsMessage || props.noDataMessage || 'No data to display'}
              </TableCell>
            </MuiTableRow>
          )}
        </TableBody>
      </MuiTable>
    </TableContainer>
  )
}
